import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitAgentIncomeReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/agent_income_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/agent_income_report?${paginate}`,
    data
  );
};

export const submitSiteIncomeReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/site_income_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/site_income_report?${paginate}`,
    data
  );
};
